import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { doctor03 } from "../../imagepath"; // Replace with a business-related image if needed
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import config from "../../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BusinessHeader from "../../BusinessHeader";
import SidebarAdmin from "../../SidebarAdmin";

const ProfileBusiness = () => {
  const [businessInfo, setBusinessInfo] = useState({});
  const [loading, setLoading] = useState(true);

  const businessId = localStorage.getItem("BusinessID"); // Use 'BusinessID' as in old code

  // Fetch business data
  useEffect(() => {
    if (businessId) {
      fetch(`${config.API_URL}get_businessdata.php?business_id=${businessId}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success === "1") {
            setBusinessInfo(data.business);
          } else {
            toast.error(data.message || "Failed to fetch business data.");
          }
        })
        .catch((error) => {
          console.error("Error fetching business data:", error);
          toast.error("Error fetching business data.");
        })
        .finally(() => setLoading(false));
    } else {
      toast.error("Business ID is missing.");
      setLoading(false);
    }
  }, [businessId]);

  return (
    <>
      <ToastContainer />
      <BusinessHeader />
      <SidebarAdmin />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-7 col-6">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <i className="feather-chevron-right">
                    <FeatherIcon icon="chevron-right" />
                  </i>
                </li>
                <li className="breadcrumb-item active">Business Profile</li>
              </ul>
            </div>
            <div className="col-sm-5 col-6 text-end m-b-30">
              <Link to="/edit-profile-business" className="btn btn-primary btn-rounded">
                <i className="fa fa-plus" /> Edit Business Profile
              </Link>
            </div>
          </div>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <>
              <div className="card-box profile-header">
                <div className="row">
                  <div className="col-md-12">
                    <div className="profile-view">
                      <div className="profile-img-wrap">
                        <div className="profile-img">
                          <Link to="#">
                            <img
                              className="avatar"
                              src={
                                businessInfo.profile_image
                                  ? `${config.API_URL}uploads/profile_images/business_images/${businessInfo.profile_image}`
                                  : doctor03
                              }
                              alt="Business Profile"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="profile-basic">
                        <div className="row">
                          <div className="col-md-5">
                            <div className="profile-info-left">
                              <h3 className="user-name m-t-0 mb-0">
                                {businessInfo.institution_name || "Business Name"}
                              </h3>
                              <small className="text-muted">Business</small>
                              <div className="staff-id">Business ID: {businessId || "N/A"}</div>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <ul className="personal-info">
                              <li>
                                <span className="title">Phone:</span>
                                <span className="text">
                                  <Link to="#">
                                    {businessInfo.mobile_number || "Not provided"}
                                  </Link>
                                </span>
                              </li>
                              <li>
                                <span className="title">Email:</span>
                                <span className="text">
                                  <Link to="#">{businessInfo.email || "Not provided"}</Link>
                                </span>
                              </li>
                              <li>
                                <span className="title">Vanity URL:</span>
                                <span className="text">
                                  {businessInfo.vanity_url || "Not provided"}
                                </span>
                              </li>
                              <li>
                                <span className="title">Address:</span>
                                <span className="text">
                                  {businessInfo.address_line1 || ""}{" "}
                                  {businessInfo.address_line2
                                    ? `, ${businessInfo.address_line2}`
                                    : ""}{" "}
                                  {businessInfo.city || ""} {businessInfo.state || ""}{" "}
                                  {businessInfo.pin_code || ""}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile-tabs">
                <ul className="nav nav-tabs nav-tabs-bottom">
                  <li className="nav-item">
                    <Link className="nav-link active" to="#about-cont" data-bs-toggle="tab">
                      About
                    </Link>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane show active" id="about-cont">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card-box">
                          <h3 className="card-title">Business Information</h3>
                          <div className="experience-box">
                            <ul className="experience-list">
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Institution Name</span>
                                    <div>
                                      {businessInfo.institution_name || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Vanity URL</span>
                                    <div>
                                      {businessInfo.vanity_url || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Institute Type</span>
                                    <div>
                                      {businessInfo.institute_type || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Specializations</span>
                                    <div>
                                      {businessInfo.specializations || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Email</span>
                                    <div>{businessInfo.email || "Not provided"}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Mobile Number</span>
                                    <div>
                                      {businessInfo.mobile_number || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Additional Phones</span>
                                    <div>
                                      {businessInfo.additional_phones || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Additional Emails</span>
                                    <div>
                                      {businessInfo.additional_emails || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Address Line 1</span>
                                    <div>
                                      {businessInfo.address_line1 || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Address Line 2</span>
                                    <div>
                                      {businessInfo.address_line2 || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">City</span>
                                    <div>{businessInfo.city || "Not provided"}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">State</span>
                                    <div>{businessInfo.state || "Not provided"}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Pin Code</span>
                                    <div>
                                      {businessInfo.pin_code || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">GST Number</span>
                                    <div>{businessInfo.gst || "Not provided"}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">PAN Card</span>
                                    <div>
                                      {businessInfo.pan_card || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Udyam Aadhaar</span>
                                    <div>
                                      {businessInfo.udyam_Aadhaar || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileBusiness;